import config from '@/config'
import { env } from '@/env'

console.log(env, 'test')
//eslint-disable-next-line
console.log(`Configuring for environment: '${env}'`)

export const cfg = config(env)
